import { UserId } from '../account';
import { CompactManagementFormResponse } from '../managementForms';
import { TeamId } from '../team';

export type FormLibraryFolderID = string;
export type FormLibraryFoldeItemrID = string;

export enum FormLibraryItemType {
  folder = 'folder',
  form = 'form',
}
export interface FormLibraryFolderResponse {
  id: FormLibraryFolderID;
  name: string;
  parentId: FormLibraryFolderID;
  subfolders: FormLibraryFolderResponse[];
  type: FormLibraryItemType;
  shares: FormLibraryItemShareItem[];
  canManage: boolean;
  isEmpty: boolean;
}

export interface FetchLibraryFoldersQuery {
  parentId: FormLibraryFolderID;
}

export interface FormLibraryItemResponse {
  id: FormLibraryFoldeItemrID;
  type: FormLibraryItemType;
  form: CompactManagementFormResponse;
  shares: FormLibraryItemShareItem[];
  canManage: boolean;
}

export interface FormLibraryResponse {
  items: FormLibraryFolderResponse[] | FormLibraryItemResponse[];
  breadcrumbs: FormLibraryFolderBreadcrumb[];
}

export interface FormLibraryFolderBreadcrumb {
  id: string;
  name: string;
}

export interface FormLibraryItemShareItem {
  userId: UserId | null;
  teamId: TeamId | null;
  view: boolean;
  manage: boolean;
  type: FormLibraryItemType;
}
